import React from 'react';

import ImpactPostsListPage from './components/ImpactPostsListPage/ImpactPostsListPage';

export default props => <ImpactPostsListPage postsPerPage={10} {...props} />;
